import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { SubCategoryApi } from 'api';

export const findSubCategory = createAsyncThunk(
  'subCategory/findSubCategory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await SubCategoryApi.findMasterData();

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {}

const initialState: IState = {};

const subCategorySlice = createSlice({
  name: 'subCategory',
  initialState,
  reducers: {},
});

const { reducer: subCategoryReducer } = subCategorySlice;

export default subCategoryReducer;
